import { useRequest } from '@Contexts/Request';

import type { ConstructorValueData } from '@Pages/PageProduct';

// Возвращает ключи кэширования для конструкторв
function useKeys(id: number, selectedPv: ConstructorValueData[]) {
  const { region, language } = useRequest();

  const addKeys = selectedPv
    .sort((a, b) => a.type.length - b.type.length)
    .map((item) => item.value);

  return ['configurator-on-page', { region, lang: language.id, id, addKeys }];
}

export default useKeys;
